import { Badge, Tooltip } from '@chakra-ui/react';
import React from 'react';

interface TwoFactorBadgeProps {
  enabled: boolean;
  enabledAt?: number | null;
  lastUsedAt?: number | null;
}

export const TwoFactorBadge: React.FC<TwoFactorBadgeProps> = ({
  enabled,
  enabledAt,
  lastUsedAt,
}) => {
  if (!enabled) {
    return (
      <Badge colorScheme="gray" variant="subtle">
        Not Set
      </Badge>
    );
  }

  const tooltipLabel = [
    enabledAt && `Enabled: ${new Date(enabledAt).toLocaleDateString()}`,
    lastUsedAt && `Last used: ${new Date(lastUsedAt).toLocaleDateString()}`,
  ]
    .filter(Boolean)
    .join('\n');

  return (
    <Tooltip label={tooltipLabel} hasArrow placement="top" whiteSpace="pre-line">
      <Badge colorScheme="green" variant="subtle" cursor="help">
        Enabled
      </Badge>
    </Tooltip>
  );
};
